import { z } from 'zod';
import { xml2ast, allHtmlParsers } from '@utils/ast';
import { decodeHtmlEntities } from '@utils/common';
import { configRefs } from '@utils/constants';
import { twentyThreeAudioSchema } from './tasks/schema.twenty-three-audio.js';

const textMediaSchema = z.object({
  type: z.literal("Text"),
  text: z.string().transform(text => decodeHtmlEntities(text))
});
const imageMediaSchema = z.object({
  type: z.literal("Image"),
  title: z.string().nullish().default(null),
  src: z.string(),
  showInLightbox: z.boolean().default(false),
  altText: z.string().nullish().default(null),
  longDescription: z.string().nullish().default(null).transform(it => xml2ast(it ?? undefined, allHtmlParsers, "text/html"))
});
const videoMediaSchema = z.object({
  type: z.literal("Video"),
  title: z.string().nullish().default(null),
  showInLightbox: z.boolean().default(false),
  twentyThreeVideo: z.object({
    id: z.string(),
    token: z.string(),
    originalWidth: z.string(),
    originalHeight: z.string(),
    standardThumbnail: z.string()
  }).transform(({
    originalHeight,
    originalWidth,
    standardThumbnail,
    ...data
  }) => {
    const height = Number(originalHeight);
    const width = Number(originalWidth);
    const aspectRatio = Number.isNaN(height) || Number.isNaN(width) ? null : `${height / width * 100}%`;
    return {
      ...data,
      height: Number.isNaN(height) ? null : height,
      width: Number.isNaN(width) ? null : width,
      thumbnail: `${configRefs.apis.video23.video.dangerouslyAssertSyncValue()}${standardThumbnail}`,
      aspectRatio
    };
  })
});
const linkMediaSchema = z.object({
  type: z.literal("Link"),
  text: z.string().default(""),
  url: z.string()
});
const audioMediaSchema = z.object({
  type: z.literal("Audio"),
  title: z.string().nullish().default(null),
  src: z.string().nullish().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => {
  return {
    ...rest,
    id: twentyThreeAudio?.id || rest.src,
    src: twentyThreeAudio?.src || rest.src || ""
  };
});
const mediaSchema = z.discriminatedUnion("type", [textMediaSchema, imageMediaSchema, videoMediaSchema, linkMediaSchema, audioMediaSchema]);

export { audioMediaSchema, imageMediaSchema, linkMediaSchema, mediaSchema, textMediaSchema, videoMediaSchema };
//# sourceMappingURL=media.js.map
